import styled from 'styled-components';
import { IModalPropsStyle } from './types';

export const StyledModal = styled.div<IModalPropsStyle>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  display: flex;
  width: ${(props) => props.width && props.width};
  max-width: ${(props) => props.maxWidth && props.maxWidth};
  padding: ${(props) => props.padding && props.padding};
  flex-direction: column;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 10px 45px 0px rgba(14, 40, 83, 0.07);

  > svg {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 12px;
    top: 12px;
    cursor: pointer;
    z-index: 1;

    path {
      fill: ${({ theme }) => theme.color.grey500};
    }
  }
`;
